import { restRepository } from "@onair/repositories";
import { useQuery } from "@tanstack/react-query";
export const useGetNotificationQuery = (options: {
	role?:
		| "SUPER_ADMIN"
		| "ADMIN"
		| "PRODUCT_OWNER"
		| "ACA_PARTNER"
		| "MARKETING"
		| "SALE"
		| "HOST"
		| "USER";
	limit: number;
	enabled?: boolean;
}) => {
	const { role, limit, enabled = true } = options;
	return useQuery({
		queryKey: ["notifications", options],
		queryFn: () =>
			restRepository.api.getAllNotifications({
				role,
				limit,
			}),
		enabled,
	});
};
